import { Button, Container, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const ERROR_MESSAGES: Record<string, { title: string; message: string }> = {
  expired: {
    title: 'Magic link expired',
    message: 'This magic link has expired. Please go back and request a new one.',
  },
  already_used: {
    title: 'Magic link already used',
    message: 'This magic link has already been used. Each link can only be used once. Please request a new one.',
  },
  invalid_token: {
    title: 'Invalid magic link',
    message: 'This magic link is invalid. Please request a new one.',
  },
  auth_failed: {
    title: 'Authentication failed',
    message: 'Something went wrong during sign in. Please try again.',
  },
};

const DEFAULT_ERROR = {
  title: 'Something went wrong',
  message: 'An unexpected error occurred. Please try signing in again.',
};

export const AuthError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('error') || '';
  const { title, message } = ERROR_MESSAGES[errorCode] || DEFAULT_ERROR;

  return (
    <Container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', height: '100vh' }}>
      <Paper sx={{ width: '100%', maxWidth: '500px' }}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} href="/" sx={{ margin: '0 auto 25px', width: '80%' }}>
            Back to Sign In
          </Button>
        </DialogActions>
      </Paper>
    </Container>
  );
};
